// Query params that carry a bearer credential and must never reach
// Sentry (breadcrumbs / request urls / transaction names). `wlt` is the
// waitlist magic-link token; `token` covers any other one-time link.
const SENSITIVE_QUERY_PARAMS = ['wlt', 'token'] as const

// Matches `?param=` or `&param=` and the value up to the next `&` or
// `#`. Surgical on purpose — only the targeted values are touched, so
// the rest of the url (path, other params, hash) is byte-for-byte
// preserved and nothing is re-encoded. Works for absolute and
// path-only urls alike, so it never throws like `new URL(relative)`.
const sensitiveParamPattern = new RegExp(
  `([?&](?:${SENSITIVE_QUERY_PARAMS.join('|')})=)[^&#]*`,
  'gi',
)

/**
 * Redact the values of sensitive query params (`wlt`, `token`) in a url,
 * leaving everything else untouched. Returns the input unchanged when it
 * is empty or carries none of the params. Safe for relative urls — never
 * throws the way `new URL(relativePath)` would.
 */
export const redactSensitiveQueryParams = (url?: string | null): string =>
  url ? url.replace(sensitiveParamPattern, '$1REDACTED') : (url ?? '')
